import { cloneElement } from 'react'

import { FormFieldConfig } from '../../../../features/ui-config'
import { getConfigTranslation } from '../../../helper/getConfigTranslation'

export function createDropDownComponent(
  config: FormFieldConfig,
  component: JSX.Element,
) {
  if (!config?.options && !component.props.options) return null

  function checkOptionsTemplate() {
    const optionsTemplate = (option: any) => {
      let languageName: string | undefined = ''

      if (option) {
        languageName = getConfigTranslation(option?.name)
      }
      return <>{languageName}</>
    }
    return optionsTemplate
  }

  function checkSelectedTemplate() {
    const optionsTemplate = (option: any) => {
      let languageName: any = null

      if (config.options?.length === 1) {
        languageName = getConfigTranslation(config?.options?.[0].name)
      } else {
        languageName = getConfigTranslation(config?.placeholder) ||
          component.props.placeholder || <>&nbsp;</>

        if (option) {
          languageName = getConfigTranslation(option?.name)
        }
      }

      return <>{languageName}</>
    }
    return optionsTemplate
  }

  return cloneElement(component, {
    options: config?.options || component.props.options,
    placeholder: getConfigTranslation(config?.placeholder) || '-',
    itemTemplate: component.props.itemTemplate || checkOptionsTemplate(),
    valueTemplate: component.props.valueTemplate || checkSelectedTemplate(),
    // If there is only one item the dropdown is disabled and value gets selected
    disabled:
      component.props.disabled || config?.options?.length === 1 ? true : false,
  })
}
